export default __webpack_public_path__ + "static/media/ba.0c577066.jpg";